import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SubpageLayout from "@/components/SubpageLayout";
import { SERVICES } from "@/pages/services";

const ServicePage = () => {
  const { slug } = useParams();
  const service = SERVICES.find((s) => s.slug === slug);

  if (!service) {
    return (
      <SubpageLayout title="Siden blev ikke fundet" testId="page-service-missing">
        <Link
          to="/vi-tilbyder"
          className="inline-flex items-center gap-2 text-sm font-medium text-[#3F5A47] transition-colors hover:text-[#B46A45]"
        >
          <ArrowLeft className="h-4 w-4" /> Tilbage til Vi tilbyder
        </Link>
      </SubpageLayout>
    );
  }

  return (
    <SubpageLayout overline="VI TILBYDER" title={service.title} testId={`page-service-${slug}`}>
      <p className="text-base leading-loose text-[#2F3338]/85">{service.text}</p>
      <p className="mt-8 text-base leading-loose text-[#2F3338]/60">
        Indholdet til denne side er på vej.
      </p>
      <p className="mt-12">
        <Link
          to="/vi-tilbyder"
          data-testid="service-back-link"
          className="inline-flex items-center gap-2 text-sm font-medium text-[#3F5A47] transition-colors hover:text-[#B46A45]"
        >
          <ArrowLeft className="h-4 w-4" /> Tilbage til Vi tilbyder
        </Link>
      </p>
    </SubpageLayout>
  );
};

export default ServicePage;
